export default __webpack_public_path__ + "media/images/images_v2/home-d119f46ad5cf84d5971a0e6c77674714.png";